// extracted by mini-css-extract-plugin
export var fileExt = "_sc-8";
export var fileIcon = "_sc-6";
export var fileLink = "_sc-5";
export var fileName = "_sc-7";
export var image = "_sc-1";
export var imageError = "_sc-3";
export var imageErrorIcon = "_sc-4";
export var imageLink = "_sc-0";
export var imageLoaded = "_sc-2";